const proposalAreas = Object.freeze({
  EducacionEspecial: 1,
  Infraestructura: 2,
  RemedioProvisional: 3,
  Transportacion: 4,
  ServiciosProfesionales: 5,
});

export default proposalAreas;
